import CodeBlock from "./CodeBlock.jsx";

// <MotorInit engine="initHotelEngine" comment="chave do sandbox, empresa SAND" />
//
// O bloco de inicialização do motor com os valores do sandbox, montado a partir
// dos tokens {SANDBOX_*} (docs.config.ts → sandbox). Escrever a key e a sigla
// à mão em cada página era exatamente o que fazia a doc divergir do sandbox.
interface MotorInitProps {
  /** Método de inicialização a chamar no fim. Vazio: nenhum. */
  engine?: string;
  /** Argumento do método, como texto JavaScript. */
  args?: string;
  /** Comentário ao lado da `key`, no idioma da página. */
  comment?: string;
  /** Inclui a linha `<script src>` do motor.js antes do bloco. */
  withScript?: boolean;
}

export default function MotorInit({
  engine = "initHotelEngine",
  args = "{}",
  comment,
  withScript = true,
}: MotorInitProps) {
  const js = [
    "const searchEngine = SearchEngine({",
    `    key: '{SANDBOX_MOTOR_KEY}',${comment ? `   // ${comment}` : ""}`,
    "    sgCompany: '{SANDBOX_CLIENT}',",
    "    b2cUrl: '{SANDBOX_B2C}',",
    "    engineBaseUrl: '{SANDBOX_HOST}',",
    "    baseUrlApi: '{SANDBOX_HOST}',",
    "    target: '_blank',",
    "})",
    ...(engine ? ["", `searchEngine.${engine}(${args})`] : []),
  ].join("\n");
  return (
    <>
      {withScript && (
        <CodeBlock>
          <code className="language-html">{'<script src="{SANDBOX_MOTOR_JS}/motor.js"></script>'}</code>
        </CodeBlock>
      )}
      <CodeBlock>
        <code className="language-javascript">{js}</code>
      </CodeBlock>
    </>
  );
}
